export { Heading as default } from "./heading.tsx";
export * from "./heading.tsx";
